const user = {
  state: {
    data: {}
  },

  mutations: {
    SET_LABEL: (state, data) => {
      state.data = data
    }
  },

  actions: {
    // 设置枚举
    set_label({ commit }, data) {
      commit('SET_LABEL', data)
    }
  }
}

export default user
